import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";

// Self-hosted Inter variable font (replaces Google Fonts CDN for GDPR/revDSG compliance)
import "@fontsource-variable/inter";
// Display-Font v2: Bricolage Grotesque, nur 600/700 (H1/H2 + grosse Preise)
import "@fontsource/bricolage-grotesque/600.css";
import "@fontsource/bricolage-grotesque/700.css";

import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import "./lib/posthog";

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_RELEASE_VERSION,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
